import { render, staticRenderFns } from "./WarehouseWrite.vue?vue&type=template&id=b2fcea58&scoped=true"
import script from "./WarehouseWrite.vue?vue&type=script&lang=js"
export * from "./WarehouseWrite.vue?vue&type=script&lang=js"
import style0 from "./WarehouseWrite.vue?vue&type=style&index=0&id=b2fcea58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fcea58",
  null
  
)

export default component.exports